import {
  Container,
  Grid,
  Box,
  TextField,
  Button,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { useState } from "react";

import Axios from "axios";
import { Helmet } from "react-helmet-async";
import { useToast } from "../../components/shared/Toast";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  page: {
    background: "#fafafa",
    padding: "48px 0 64px",
    minHeight: "60vh",
    [theme.breakpoints.down("xs")]: {
      padding: "32px 0 48px",
    },
  },
  card: {
    background: "#ffffff",
    borderRadius: 18,
    border: "1px solid rgba(76,0,76,0.08)",
    boxShadow: "0 10px 34px rgba(76,0,76,0.08)",
    padding: "32px 28px",
    [theme.breakpoints.down("xs")]: {
      padding: "24px 18px",
    },
  },
  cardTitle: {
    fontSize: "1.35rem",
    fontWeight: 700,
    color: "#4c004c",
    marginBottom: 6,
    letterSpacing: "-0.01em",
  },
  cardSub: {
    fontSize: "0.83rem",
    color: "#666",
    lineHeight: 1.6,
    marginBottom: 8,
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 12,
      backgroundColor: "rgba(255,255,255,0.7)",
      fontSize: "0.88rem",
      transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
      "& fieldset": {
        borderColor: "rgba(76,0,76,0.12)",
        transition: "border-color 0.3s ease, border-width 0.3s ease",
      },
      "&:hover fieldset": {
        borderColor: "rgba(76,0,76,0.32)",
      },
      "&.Mui-focused": {
        backgroundColor: "#ffffff",
        boxShadow: "0 0 0 4px rgba(155,59,155,0.08)",
        "& fieldset": {
          borderColor: "#4c004c",
          borderWidth: 1.5,
        },
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "13px 12px",
    },
    "& .MuiOutlinedInput-multiline": {
      padding: "13px 12px",
      "& textarea": { padding: 0 },
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.85rem",
      color: "#888",
      "&.Mui-focused": { color: "#4c004c" },
    },
  },
  submitButton: {
    background: "linear-gradient(135deg, #4c004c 0%, #6b1b6b 100%)",
    color: "#ffffff",
    padding: "14px 36px",
    borderRadius: 14,
    fontSize: "0.9rem",
    fontWeight: 600,
    textTransform: "none",
    letterSpacing: "0.2px",
    width: "100%",
    boxShadow: "0 8px 22px rgba(76,0,76,0.28)",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    "&:hover": {
      background: "linear-gradient(135deg, #6b1b6b 0%, #9b3b9b 100%)",
      transform: "translateY(-2px)",
      boxShadow: "0 14px 32px rgba(76,0,76,0.4)",
    },
    "&:disabled": {
      background: "#cccccc",
      boxShadow: "none",
      color: "#ffffff",
    },
  },
}));

export const Feedback = () => {
  const classes = useStyles();

  const [projname, setProjName] = useState("");
  const [name, setName] = useState("");

  const [subj, setSubj] = useState("");
  const [msg, setMsg] = useState("");

  const [err, setErr] = useState(0);
  const [disablebutton, setDisablebutton] = useState(false);

  const toast = useToast();
  const openSnkbar = (type, message) => toast.show(type, message);

  const onSubmit = () => {
    setErr(0);
    if (projname == "") {
      setErr(1);
      openSnkbar("error", "Please Enter Your Project / Institute Name....");
    } else if (name == "") {
      setErr(2);
      openSnkbar("error", "Please Enter Your name with Designation....");
    } else if (subj == "") {
      setErr(4);
      openSnkbar("error", "Please Enter Your Subject....");
    } else if (msg == "") {
      setErr(5);
      openSnkbar("error", "Please Enter Your Message....");
    } else {
      openSnkbar("warning", "Please wait.....");
      setDisablebutton(true);
      const formData = new FormData();
      formData.append("name", projname);
      formData.append("profname", name);

      formData.append("sub", subj);
      formData.append("msg", msg);
      Axios.post("/api/addtest", formData, {
        headers: { headKey: headKey },
      })
        .then((res) => {
          if (res.data.status) {
            setDisablebutton(false);
            setProjName("");
            setName("");
            setSubj("");
            setMsg("");
            openSnkbar("success", res.data.msg);
          } else {
            setDisablebutton(false);
            openSnkbar("error", "Something went wrong... try later.");
          }
        })
        .catch(() => {
          setDisablebutton(false);
          openSnkbar("error", "Network error. Please try again.");
        });
    }
  };

  return (
    <Box className={classes.page}>
      <Helmet>
        <title>Share Your Feedback | Arawinz Soft Solutions</title>
      </Helmet>
      <Container maxWidth="sm">
        <Box className={classes.card}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography className={classes.cardTitle}>
                Share your feedback
              </Typography>
              <Typography className={classes.cardSub}>
                Tell us how your project went. Your words help us do better
                work.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="feedback-project-name"
                label="Project / Institute Name"
                variant="outlined"
                error={err === 1 && true}
                value={projname}
                size="small"
                className={classes.textField}
                onChange={(e) => {
                  setProjName(e.target.value);
                }}
                required
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="feedback-name"
                label="Your Name with Designation"
                variant="outlined"
                error={err === 2 && true}
                value={name}
                size="small"
                className={classes.textField}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                required
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                id="feedback-subject"
                label="Subject"
                variant="outlined"
                error={err === 4 && true}
                value={subj}
                size="small"
                className={classes.textField}
                onChange={(e) => {
                  setSubj(e.target.value);
                }}
                required
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="feedback-message"
                label="Message"
                variant="outlined"
                error={err === 5 && true}
                value={msg}
                size="small"
                className={classes.textField}
                multiline
                rows={4}
                onChange={(e) => {
                  setMsg(e.target.value);
                }}
                required
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                onClick={onSubmit}
                className={classes.submitButton}
                fullWidth
                disabled={disablebutton}
              >
                {disablebutton ? "Sending..." : "Submit Feedback"}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};
